import { render, staticRenderFns } from "./SpecimenWeightDetailModal.vue?vue&type=template&id=2ba57067"
import script from "./SpecimenWeightDetailModal.vue?vue&type=script&lang=js"
export * from "./SpecimenWeightDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports